// extracted by mini-css-extract-plugin
export default {"link":"SN-z","disabled":"TN-z"};